var currencyRounder = function () {
  var decimalPrecisions = {
    PENNY: '0.01',
    NICKEL: '0.05',
    DIME: '0.1',
    HALF: '0.5',
    WHOLE_NUMBER: '1',
    FIVE: '5',
    TEN: '10',
    HUNDRED: '100',
  }

  var roundTypes = {
    UP: 'Up',
    DOWN: 'Down',
    STANDARD: 'Standard',
  }
  var arrstrAllowedDecimalPrecisions = Object.values(decimalPrecisions)
  var arrstrAllowedRoundTypes = Object.values(roundTypes)

  var isValidArray = function (arrInput) {
    return 'undefined' !== typeof arrInput && 0 < arrInput.length
  }

  var init = function (
    _arrstrAllowedDecimalPrecisions,
    _arrstrAllowedRoundTypes
  ) {
    if (isValidArray(_arrstrAllowedDecimalPrecisions)) {
      arrstrAllowedDecimalPrecisions = _arrstrAllowedDecimalPrecisions
    }

    if (isValidArray(_arrstrAllowedRoundTypes)) {
      arrstrAllowedRoundTypes = _arrstrAllowedRoundTypes
    }
  }

  var round = function (_fltAmount, _fltDecimalPrecision, _strRoundMethod) {
    var fltAmount = parseFloat(_fltAmount)
    var strRoundMethod =
      _strRoundMethod ||
      (window.__LOCALE_DATA__ &&
        window.__LOCALE_DATA__.boolAllowDecimalPrecision &&
        window.__LOCALE_DATA__.roundType &&
        window.__LOCALE_DATA__.roundType) ||
      'Standard'
    var fltDecimalPrecision =
      _fltDecimalPrecision ||
      (window.__LOCALE_DATA__ &&
        window.__LOCALE_DATA__.boolAllowDecimalPrecision &&
        window.__LOCALE_DATA__.decimalPrecision &&
        parseFloat(window.__LOCALE_DATA__.decimalPrecision)) ||
      0.01

    if (
      false ===
      arrstrAllowedDecimalPrecisions.includes(fltDecimalPrecision.toString())
    ) {
      throw new TypeError('Invalid Decimal Precision.')
    } else if (false === arrstrAllowedRoundTypes.includes(strRoundMethod)) {
      throw new TypeError('Invalid Round Type.')
    } else if (Number.isNaN(fltAmount)) {
      throw new TypeError('Invalid Amount.')
    }

    var arrSplitDecimalPrecision = fltDecimalPrecision.toString().split('.')

    // step 1 Calculate Decimal Precision
    var intAllowedDecimalPrecision = 0
    if (1 < arrSplitDecimalPrecision.length) {
      intAllowedDecimalPrecision = arrSplitDecimalPrecision[1].length
    }

    // step 2 Take reminder of amount with decimal precision value
    var fltUnsupportedFraction = floatMod(fltAmount, fltDecimalPrecision)

    // Step 3 Remove reminder from amound
    var fltRoundAmount = fltAmount - fltUnsupportedFraction

    // step 4 take devision of decimal precision by 2
    var fltDecimalPrecisionHalf = fltDecimalPrecision / 2

    // step 5 Compire reminder with step 1 & step 2 value depends n that calculate rounded amount
    if (
      'Standard' === strRoundMethod &&
      Math.abs(fltUnsupportedFraction) >= fltDecimalPrecisionHalf
    ) {
      var boolIsPositive = fltAmount > 0
      fltRoundAmount = boolIsPositive
        ? fltRoundAmount + fltDecimalPrecision
        : fltRoundAmount - fltDecimalPrecision
    } else if (
      'Up' === strRoundMethod &&
      0 < fltAmount &&
      0 < fltUnsupportedFraction
    ) {
      fltRoundAmount = fltRoundAmount + fltDecimalPrecision
    } else if (
      'Down' === strRoundMethod &&
      0 > fltAmount &&
      0 > fltUnsupportedFraction
    ) {
      fltRoundAmount = fltRoundAmount - fltDecimalPrecision
    }

    return fltRoundAmount.toFixed(intAllowedDecimalPrecision)
  }

  var floatMod = function (fltAmount, fltDecimalPrecision) {
    return (
      ((fltAmount.toFixed(6) * 1000000) %
        (fltDecimalPrecision.toFixed(6) * 1000000)) /
      1000000
    )
  }

  return {
    init: init,
    round: round,
  }
}
module.exports = currencyRounder
